import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { FaUser } from "react-icons/fa";
import "../../App.css";
import axios from "axios";
import AdminLoader from "../../components/common/loader/AdminLoader";
import config from "../../config/api";
import logo from "../../assets/peopleskillLogo.svg"
import { CheckCircle2 } from "lucide-react";


const Forgotpw = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const emailPrevious = location.state?.email;
  const [email, setemail] = useState(emailPrevious || ""); // Initialize with previous email if available
  const BackendURL = config.backendUrl;
  const [isLoading, SetisLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isEmailSent, setIsEmailSent] = useState(false);

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (!email) {
      enqueueSnackbar("Please enter email correctly!", { variant: "error" });

    } else {
      SetisLoading(true);
      try {
        const response = await axios.post(
          `${BackendURL}/pass/forgot-password`,
          { email: email }
        );
        if (response.status >= 200 && response.status < 300) {
          enqueueSnackbar(
            "Kindly check your email! We have sent you a link to reset your password.",
            { variant: "success" }
          );
          setMessage(
            `Kindly check your entered email, We have sent you a link to reset your password.`
          );
          setIsEmailSent(true);
          setemail("");
          setTimeout(() => {
            navigate("/");
          }, 5000);
        } else {
          enqueueSnackbar("Incorrect Email!", { variant: "error" });
          setemail("");
        }
      } catch (error) {
        console.error("Error during forgot password process:", error);
        enqueueSnackbar("Please Enter Valid Email!", { variant: "error" });
      } finally {
        SetisLoading(false);
      }
    }
  };

  const HandleBack = () => {
    navigate("/");
  };

  return (
    <>
      {isLoading ? (
        <AdminLoader isLoading={isLoading} />
      ) : (
        <div className="min-h-screen flex items-center bg-gray-100 justify-center">
          <div className="text-center my-20 px-24 py-10 w-[42%] bg-[#fbfafb] overflow-hidden shadow-2xl rounded-lg border border-gray-200">
            <h1 className="text-5xl font-extrabold">
              <img src={logo} alt="loginlogo" className="scale-90" />
            </h1>
            <br />
            <br />

            {!isEmailSent && (
              <>
                <h1 className="font-extrabold text-2xl mb-7">
                  Forgot Password?
                </h1>
                <div className="flex justify-center">
                  <FaUser
                    style={{ alignItems: "center", marginTop: "2%" }}
                    size={24}
                  />
                  <input
                    className="border ml-2 w-full border-gray-300 rounded-md p-2 overflow-hidden shadow-md outline-none"
                    value={email}
                    type="text"
                    placeholder="Enter Email"
                    onChange={(e) => setemail(e.target.value)}
                  />
                </div>
                <br />

              </>
            )}

            {isEmailSent ? (
              <div className="flex flex-col items-center">
                <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                  <CheckCircle2 size={36} strokeWidth={2.2} />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Check Your Email</h2>
                <div className="mt-4 max-w-md rounded-lg border border-blue-100 bg-blue-50 px-6 py-5 text-center shadow-sm">
                  <p className="text-lg font-medium text-gray-800">{message}</p>
                  <p className="mt-3 text-sm text-gray-600">
                    You will be redirected to the login page shortly.
                  </p>
                </div>
                <div className="mt-6 flex justify-center align-middle items-center gap-2">
                  <button
                    onClick={HandleBack}
                    className="py-2 text-center shadow-md rounded-sm text-white w-40 px-6 border bg-gray-600 hover:bg-gray-900"
                  >
                    Back To Login
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex justify-center align-middle items-center gap-2">
                <button
                  onClick={handleConfirm}
                  className="py-1 text-center overflow-hidden shadow-md w-40 rounded-sm text-white px-6 bg-blue-600 hover:bg-blue-900"
                >
                  Confirm
                </button>
                <button
                  onClick={HandleBack}
                  className="py-1 text-center shadow-md rounded-sm text-white  w-40 px-6 border bg-gray-600 hover:bg-gray-900"
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Forgotpw;
